/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_Line_BreaksInputs */



/**
* | output |
* | --- |
* | "Line breaks changed" |
*
* @param {Assistant_Activity_Line_BreaksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_line_breaks = /** @type {((inputs?: Assistant_Activity_Line_BreaksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Line_BreaksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les sauts de ligne ont été modifiés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeilenumbrüche geändert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Interruzioni di riga modificate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменены переносы строк")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se cambiaron los saltos de línea.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("换行符已更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("改行が変更されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइन ब्रेक बदल गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quebras de linha alteradas")
	return /** @type {LocalizedString} */ ("Line breaks changed")
});